interface ViewBox {
  left: number;
  right: number;
  top: number;
  bottom: number;
}
class ContentCard {
  cardNode: HTMLElement;
  id: string;
  width: number;
  height: number;
  marginBottom: number;
  marginTop: number;
  /* ---- start of constructor functions ---- */
  constructor(
    cardNode: HTMLElement,
    onMouseoverCallback: Function,
    onMouseoutCallback: Function,
    onMouseclickCallback: Function
  ) {
    this.id = "";
    this.cardNode = cardNode;
    this.width = 264;
    this.height = 148;
    this.marginBottom = 20;
    this.marginTop = 8;
    this.cardNode.addEventListener("click", () => {
      onMouseclickCallback(this.id);
    });
    this.cardNode.addEventListener("mouseenter", () => {
      onMouseoverCallback(this.id);
    });
    this.cardNode.addEventListener("mouseleave", () => {
      onMouseoutCallback(this.id);
    });
  }

  private clipToRange(val: number, min: number, max: number) {
    let newVal: number = Math.max(min, val);
    newVal = Math.min(newVal, max);
    return newVal;
  }

  private setCardTop(y: number, boundingBox: ViewBox): number {
    // content card defaults to position above y
    const cardTop = y - (this.height + this.marginBottom);
    // clip card so it does not got beyond top of screen
    let newCardTop: number = this.clipToRange(
      cardTop,
      boundingBox.top - this.marginTop,
      boundingBox.bottom
    );
    // if card is above top of screen then position it below y
    if (newCardTop !== cardTop) {
      newCardTop = y + this.marginBottom;
    }
    return newCardTop;
  }

  public show(
    id: string,
    content: string,
    screenLocation: { x: number; y: number },
    boundingBox: ViewBox
  ) {
    this.cardNode.innerHTML = content;
    this.cardNode.classList.remove("content-card--hide");
    const cardLeft: number = this.clipToRange(
      screenLocation.x - Math.round(this.width / 2),
      boundingBox.left,
      boundingBox.right - this.width
    );
    const cardTop: number = this.setCardTop(screenLocation.y, boundingBox);
    this.cardNode.style.left = `${cardLeft}px`;
    this.cardNode.style.top = `${cardTop}px`;
    this.id = id;
  }

  public hide() {
    this.cardNode.classList.add("content-card--hide");
  }
}

export { ContentCard };
